import { crispInstance } from '@declaration/plugins/crisp';
export function crispSetNickname(nickname) {
    var _a;
    (_a = crispInstance()) === null || _a === void 0 ? void 0 : _a.push(['set', 'user:nickname', [nickname]]);
}
export function crispPushData(key, value) {
    var _a;
    (_a = crispInstance()) === null || _a === void 0 ? void 0 : _a.push(['set', 'session:data', [key, value]]);
}
